import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {Button, withStyles} from "@material-ui/core";
import React, {MouseEvent} from "react";
import {compose} from "redux";
import {useTranslation} from "react-i18next";

export interface Props {
    title: string | JSX.Element | Array<JSX.Element>;
    content: string | JSX.Element | Array<JSX.Element>;
    isOpen: boolean;
    onClose: (e: MouseEvent<HTMLButtonElement>) => void;
    onConfirm: (e: MouseEvent<HTMLButtonElement>) => void;
}

interface InnerProps extends Props {
    classes: Record<string, string>;
}

const ConfirmDialog: React.FunctionComponent<InnerProps> =
    ({title, content, isOpen, onClose, onConfirm, classes, ...rest}: InnerProps) => {
        const {t: translate} = useTranslation();

        return (
            <Dialog
                {...rest}
                open={isOpen}
                onClose={onClose}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle className={classes.title}>
                    {title}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.content}>
                        {content}
                    </div>
                    <div className={classes.toolbar}>
                        <Button
                            onClick={onConfirm}
                            color="primary"
                            size='medium'
                            variant='contained'
                        >
                            {translate('common.actions.confirm')}
                        </Button>
                        <Button
                            onClick={onClose}
                            color="primary"
                            size='medium'
                            variant='outlined'
                        >
                            {translate('common.actions.cancel')}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        );
    };

export default compose(
    withStyles({
        toolbar: {
            marginTop: '16px',
            marginBottom: '4px',
            display: 'flex',
            justifyContent: 'space-between',
        },
        title: {
            textAlign: 'center',
            fontSize: '16pt'
        },
        content: {
            textAlign: 'center',
            fontSize: '12pt'
        },
    }),
)(ConfirmDialog);